/* Hangar9 continuous scroll for collection pages. No libraries. */
(function () {
  'use strict';
  var GRID = 'main-collection-product-grid';
  var WRAP = 'CollectionProductGrid';
  var STORE_KEY = 'h9cs:';
  var MAX_AGE = 30 * 60 * 1000; // remember position for 30 minutes
  var state = null;
  var io = null;
  var restoring = false;

  function el(sel, root) { return (root || document).querySelector(sel); }
  function key() {
    var p = new URLSearchParams(location.search);
    p.delete('page'); p.delete('section_id');
    var q = p.toString();
    return STORE_KEY + location.pathname + (q ? '?' + q : '');
  }
  function sectionUrl(href, sectionId) {
    var u = new URL(href, location.origin);
    if (sectionId) u.searchParams.set('section_id', sectionId);
    return u.toString();
  }
  function cleanUrl(href) {
    var u = new URL(href, location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  function init() {
    if (io) { io.disconnect(); io = null; }
    var root = el('[data-h9cs]');
    var grid = document.getElementById(GRID);
    if (!root || !grid) { state = null; return; }
    document.documentElement.classList.add('h9cs-on');
    root.hidden = false;
    state = {
      root: root,
      grid: grid,
      next: root.dataset.next ? cleanUrl(root.dataset.next) : '',
      total: +root.dataset.total || 0,
      from: +root.dataset.from || 1,
      to: +root.dataset.to || 0,
      section: root.dataset.section,
      auto: Math.max(0, +root.dataset.auto || 0),
      loads: 0,
      pages: [],
      busy: false
    };
    var btn = el('[data-h9cs-btn]', root);
    btn.addEventListener('click', function () { load(); });
    render();
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) check();
      }, { rootMargin: '0px 0px 900px 0px' });
      io.observe(el('[data-h9cs-sentinel]', root));
    }
    check();
  }

  // Load the next page when the end of the grid is within ~900px of the screen.
  // Runs from the observer and from a light scroll listener (some browsers and
  // embedded views don't report intersections reliably).
  function check() {
    var s = state;
    if (restoring || !s || s.busy || !s.next || s.loads >= s.auto) return;
    var sentinel = el('[data-h9cs-sentinel]', s.root);
    if (!sentinel) return;
    if (sentinel.getBoundingClientRect().top - window.innerHeight < 900) load();
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; check(); });
    setTimeout(function () { if (ticking) { ticking = false; check(); } }, 250);
  }

  function render() {
    var s = state, r = s.root;
    var text = s.from > 1 ? ('Showing ' + s.from + '–' + s.to + ' of ' + s.total) : ('Showing ' + s.to + ' of ' + s.total);
    el('[data-h9cs-text]', r).textContent = text;
    el('[data-h9cs-bar]', r).style.width = Math.round((s.to / Math.max(1, s.total)) * 100) + '%';
    el('[data-h9cs-btn]', r).hidden = !s.next || s.busy || s.loads < s.auto;
    el('[data-h9cs-loading]', r).hidden = !s.busy;
  }

  function fetchPage(url) {
    return fetch(sectionUrl(url, state.section), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  function append(doc, url) {
    var cards = doc.querySelectorAll('#' + GRID + ' .js-product-listing');
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) {
      if (!document.getElementById(c.id)) frag.appendChild(document.importNode(c, true));
    });
    state.grid.appendChild(frag);
    var nr = doc.querySelector('[data-h9cs]');
    state.next = nr && nr.dataset.next ? cleanUrl(nr.dataset.next) : '';
    state.to = nr ? +nr.dataset.to : state.to + cards.length;
    state.pages.push(url);
    // Re-run the theme's quick view binding for the new cards.
    try { if (window.Shopify && Shopify.theme && Shopify.theme.quickview) Shopify.theme.quickview.init(); } catch (e) {}
    try { if (window.lazySizes) lazySizes.autoSizer.checkElems(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('h9:products-loaded', { detail: { url: url, count: cards.length } }));
  }

  function load() {
    var s = state;
    if (!s || s.busy || !s.next) return Promise.resolve();
    s.busy = true; render();
    var url = s.next;
    return fetchPage(url).then(function (doc) {
      // Ignore the result if filters changed while it was loading.
      if (state !== s || !document.body.contains(s.grid)) return;
      append(doc, url);
      s.loads++;
    }).catch(function () {
      // On error fall back to the next page link, so nothing is lost.
      s.auto = 0;
    }).then(function () { s.busy = false; if (state === s) { render(); check(); } });
  }

  /* Remember how far the shopper scrolled, so Back from a product page restores it. */
  function save() {
    if (!state || !state.pages.length) return;
    try {
      sessionStorage.setItem(key(), JSON.stringify({ pages: state.pages, y: window.scrollY, t: Date.now() }));
    } catch (e) {}
  }

  function cameBack() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return performance.navigation && performance.navigation.type === 2;
    } catch (e) { return false; }
  }

  function readSaved() {
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(key()) || 'null');
      sessionStorage.removeItem(key());
    } catch (e) { saved = null; }
    if (!cameBack() || !saved || Date.now() - saved.t > MAX_AGE || !saved.pages || !saved.pages.length) return null;
    return saved;
  }

  function restore(saved) {
    if (!saved || !state) { restoring = false; return; }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var s = state, pages = saved.pages.slice(0, 12);
    var chain = Promise.resolve();
    pages.forEach(function (url) {
      chain = chain.then(function () {
        if (state !== s || s.next !== url) return;
        s.busy = true; render();
        return fetchPage(url).then(function (doc) { append(doc, url); s.loads++; })
          .catch(function () {})
          .then(function () { s.busy = false; render(); });
      });
    });
    chain.then(function () {
      restoring = false;
      window.scrollTo(0, saved.y || 0);
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    });
  }

  function start() {
    var saved = readSaved();
    restoring = !!saved;
    init();
    restore(saved);
    window.addEventListener('pagehide', save);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#' + GRID + ' a[href]')) save();
    }, true);
    // The theme's filters replace the grid's markup; start again when they do.
    var wrap = document.getElementById(WRAP);
    if (wrap && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        if (!muts.some(function (m) { return m.target === wrap; })) return;
        if (state && document.body.contains(state.root)) return;
        init();
      }).observe(wrap, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
